module.exports = __webpack_public_path__ + "static/media/welcome-infog.a02dbdfa.png";